import {
  CellTemplate,
  Compatible,
  isAlphaNumericKey,
  keyCodes,
  Uncertain,
  UncertainCompatible,
} from "@silevis/reactgrid";
import { ReactNode } from "react";
import { DatePicker } from "antd";
import { DATE_TIME_FORMAT } from "@lhd/constants";
import { Styles } from "./Style";
import moment from "moment";
import { CellCustomType } from "../../type";

export class TimeCellTemplate implements CellTemplate<CellCustomType> {
  getCompatibleCell(
    uncertainCell: Uncertain<CellCustomType>,
  ): Compatible<CellCustomType> {
    const uncertainCellAs = uncertainCell as CellCustomType;
    return {
      value: NaN,
      ...uncertainCellAs,
    };
  }

  getClassName(
    cell: Compatible<CellCustomType>,
    isInEditMode: boolean,
  ): string {
    return cell.className || "";
  }

  update(
    cell: Compatible<CellCustomType>,
    cellToMerge: UncertainCompatible<CellCustomType>,
  ): Compatible<CellCustomType> {
    return this.getCompatibleCell({ ...cell, text: cellToMerge.text });
  }

  handleKeyDown(
    cell: Compatible<CellCustomType>,
    keyCode: number,
    ctrl: boolean,
    shift: boolean,
    alt: boolean,
  ): { cell: Compatible<CellCustomType>; enableEditMode: boolean } {
    if (!ctrl && !alt && isAlphaNumericKey(keyCode))
      return { cell, enableEditMode: true };
    return {
      cell,
      enableEditMode:
        keyCode === keyCodes.POINTER || keyCode === keyCodes.ENTER,
    };
  }
  render(
    cell: Compatible<CellCustomType>,
    isInEditMode: boolean,
    onCellChanged: (cell: Compatible<CellCustomType>, commit: boolean) => void,
  ): ReactNode {
    if (!isInEditMode) return cell.displayText;
    return (
      <Styles
        onClick={(e) => {
          e.preventDefault();
        }}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <DatePicker
          format={DATE_TIME_FORMAT.TIME}
          defaultOpen
          picker="time"
          defaultValue={cell.text ? moment(cell.text) : undefined}
          onChange={(date) => {
            const updatedCell = this.getCompatibleCell({
              ...cell,
              text: date ? date.format(DATE_TIME_FORMAT.DATE_TIME) : "",
            });
            onCellChanged(updatedCell, true);
          }}
        />
      </Styles>
    );
  }
}
